// extracted by mini-css-extract-plugin
module.exports = {"pagMesInfo":"codiespectador_pagMesInfo__u_NVi","clickable":"codiespectador_clickable__xb11l"};